import { useCallback } from 'react';
import camelCase from 'lodash/camelCase';
import type { IBreadcrumbItem } from 'dash-ui';

import { RoutesPath } from 'flow-components/routes/routes';
import type {
  IBreadcrumbScopeBuildHookParams,
  IBreadcrumbScopeBuildParams,
} from 'common/hooks/use-breadcrumb-builder/breadcrumbs-scope-builders/';
import { DEFAULT_ORGANIZATION_TAB_KEY } from 'pages/OrganizationPage/OrganizationDetailsPage/components/OrganizationDetailsTabs/OrganizationDetailsTabs.constants';

export const useOrganizationsBreadcrumbBuilder = (): [
  IBreadcrumbScopeBuildHookParams
] => {
  const getAsyncOrganizationsBreadcrumbItems = useCallback(
    async ({ t, currentTab }: IBreadcrumbScopeBuildParams) => {
      const items: IBreadcrumbItem[] = [];

      // home breadcrumb to organizations list
      items.push({
        icon: 'suitcase',
        label: t`organization`,
        path: RoutesPath.Organization,
      });

      if (currentTab && currentTab !== DEFAULT_ORGANIZATION_TAB_KEY) {
        // add organization tab as breadcrumb
        items.push({
          label: t(camelCase(currentTab)),
          path: `${RoutesPath.Organization}?tab=${currentTab}`,
        });
      }
      return items;
    },
    []
  );

  return [getAsyncOrganizationsBreadcrumbItems];
};
